import { render, staticRenderFns } from "./editOrderDialog.vue?vue&type=template&id=2b3dab23&scoped=true"
import script from "./editOrderDialog.vue?vue&type=script&lang=js"
export * from "./editOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./editOrderDialog.vue?vue&type=style&index=0&id=2b3dab23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3dab23",
  null
  
)

export default component.exports